export interface DateRange {
  earliest: Date;
  latest: Date;
}

// Compare dates using their raw time values because date objects themselves don't support equality comparison.
export const dateRangesEqual = (a: DateRange, b: DateRange): boolean =>
  a.earliest.getTime() === b.earliest.getTime() && a.latest.getTime() === b.latest.getTime();
